document.addEventListener("DOMContentLoaded", function () {
  // Close Modal
  function closeModal() {
    const modal = document.getElementById("customModal");
    const customFullModal = document.querySelector('.custom_full_modal');
    if (modal) modal.style.display = "none";
    if (customFullModal) customFullModal.style.display = "none";
  }

  const closeBtn = document.getElementById("closeModal");
  if (closeBtn) {
    closeBtn.onclick = function () {
      closeModal();
    };
  }

  // Show next step
function showStep(step) {
  const allSteps = document.querySelectorAll('.modal-step');
  allSteps.forEach(stepElement => {
    stepElement.style.display = 'none';
  });

  const targetStep = document.getElementById('step-' + step);
  if (targetStep) {
    targetStep.style.display = 'flex';

    
  }
}


  // Step navigation (all steps optional)
  const nextButtons = document.querySelectorAll('.next-step');
  const prevButtons = document.querySelectorAll('.prev-step');

  nextButtons.forEach(button => {
    const nextStepId = button.getAttribute('data-next');
    button.disabled = false;
    button.onclick = function () {
      if (nextStepId) showStep(nextStepId);
    };
  });

  prevButtons.forEach(button => {
    button.onclick = function () {
      const prevStepId = button.getAttribute('data-prev');
      if (prevStepId) showStep(prevStepId);
    };
  });

  // Calendar input formatting
  const calendarInput = document.getElementById("calendar");
  if (calendarInput) {
    calendarInput.addEventListener("input", function (e) {
      let value = e.target.value.replace(/\D/g, "").slice(0, 8);
      let formatted = "";

      if (value.length > 0) formatted += value.slice(0, 2);
      if (value.length > 2) formatted += "/" + value.slice(2, 4);
      if (value.length > 4) formatted += "/" + value.slice(4, 8);

      e.target.value = formatted;
    });
  }

  // "Other" allergy input visibility
  const otherAllergyRadio = document.getElementById("radio5");
  const otherAllergyContainer = document.getElementById("otherAllergyContainer");
  const otherAllergyInput = document.getElementById("otherAllergyInput");

  if (otherAllergyRadio && otherAllergyContainer && otherAllergyInput) {
    document.querySelectorAll('input[name="radios"]').forEach((radio) => {
      radio.addEventListener("change", function () {
        if (otherAllergyRadio.checked) {
          otherAllergyContainer.style.display = "flex";
        } else {
          otherAllergyContainer.style.display = "none";
          otherAllergyInput.value = "";
        }
      });
    });
  }

const doneButton = document.querySelector('.done-step');
if (doneButton) {
  doneButton.onclick = function () {
    const lineItemProperties = {};

    const dogName = document.getElementById("input1")?.value;
    if (dogName) lineItemProperties["Dog's Name"] = dogName;

    const dogType = document.querySelector('input[name="options"]:checked');
    if (dogType) lineItemProperties["Dog Type"] = dogType.nextSibling.textContent.trim();

    const selectedAllergy = document.querySelector('input[name="radios"]:checked');
    if (selectedAllergy) {
      const otherAllergyInput = document.getElementById("otherAllergyInput");
      if (selectedAllergy.value === "Other" && otherAllergyInput?.value.trim()) {
        lineItemProperties["Allergies"] = `Other: ${otherAllergyInput.value.trim()}`;
      } else {
        lineItemProperties["Allergies"] = selectedAllergy.value;
      }
    }

    const dogBirthday = document.getElementById("calendar")?.value;
    if (dogBirthday) lineItemProperties["Dog Birthday"] = dogBirthday;

    const dogSize = document.querySelector('input[name="size_image"]:checked');
    if (dogSize) {
      const sizeLabel = dogSize.closest('label')?.querySelector('p');
      if (sizeLabel) lineItemProperties["Dog Size"] = sizeLabel.textContent.trim();
    }

    const hiddenDataDiv = document.querySelector('.quiz_hidden_data');
    if (hiddenDataDiv) {
      hiddenDataDiv.innerHTML = '';
      Object.entries(lineItemProperties).forEach(([key, value]) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${key}]`;
        input.value = value;
        hiddenDataDiv.appendChild(input);
      });
    }

    // ✅ GET selling_plan_id from radio button (Appstle generates this)
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]:checked');
    const sellingPlanId = sellingPlanInput?.value;

    // ✅ Defined variantId 
  const variantId = window.selectedChewerBoxId || "49939404587306";



    // ✅ Add to cart with subscription
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId || null, // Ensure null if not selected
        properties: lineItemProperties,
      }),
    })
    .then(response => {
      if (!response.ok) throw new Error("Failed to add to cart");
      return response.json();
    })
    .then(() => {
      closeModal();
      window.location.href = "/cart";
    })
    .catch(console.error);
  };
}


  // Click-to-toggle add-on checkboxes
  document.querySelectorAll('.related-product').forEach(productEl => {
    const checkbox = productEl.querySelector('input[type="checkbox"]');
    const productId = productEl.getAttribute('data-product-id');

    if (!checkbox || !productId) return;

    productEl.addEventListener('click', (e) => {
      if (!e.target.matches('input')) {
        checkbox.checked = !checkbox.checked;
        handleCheckboxChange(checkbox, productId);
      }
    });

    checkbox.addEventListener('change', () => {
      handleCheckboxChange(checkbox, productId);
    });

    function handleCheckboxChange(checkbox, productId) {
      const route = checkbox.checked ? 'cart/add.js' : 'cart/change.js';
      const body = checkbox.checked
        ? { items: [{ id: parseInt(productId, 10), quantity: 1 }] }
        : { id: productId, quantity: 0 };

      fetch(window.Shopify.routes.root + route, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(res => res.json())
        .then(data => {
          console.log(checkbox.checked ? 'Added:' : 'Removed:', data);
        })
        .catch(err => {
          console.error('Cart update failed:', err);
        });
    }
  });
});






////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
















////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////











document.addEventListener("DOMContentLoaded", function () {
  // Ensure the script runs only when the FAQ section exists
  const faqs = document.querySelectorAll(".faq-question");

  if (faqs.length > 0) {
    faqs.forEach(faq => {
      faq.addEventListener("click", function () {
        const parent = this.parentElement;
        parent.classList.toggle("active");
      });
    });
  }
});




//Home Page IMages And Video Grid
document.addEventListener("DOMContentLoaded", function () {
  const galleryItems = document.querySelectorAll(".gallery-item img, .gallery-item video");
  
  // Create lightbox elements
  const lightbox = document.createElement("div");
  lightbox.classList.add("lightbox");
  lightbox.innerHTML = `<span class="lightbox-close">&times;</span><div class="lightbox-content"></div>`;
  document.body.appendChild(lightbox);
  const lightboxContent = lightbox.querySelector(".lightbox-content");
  const lightboxClose = lightbox.querySelector(".lightbox-close");

  // Open lightbox when clicking an image or video
  galleryItems.forEach(item => {
    item.addEventListener("click", function () {
      lightboxContent.innerHTML = item.outerHTML;
      lightbox.classList.add("visible");
    });
  });

  // Close lightbox
  lightboxClose.addEventListener("click", () => {
    lightbox.classList.remove("visible");
  });

  // Close lightbox when clicking outside content
  lightbox.addEventListener("click", (e) => {
    if (e.target === lightbox) {
      lightbox.classList.remove("visible");
    }
  });
});

//Facebook Subscription Tracker
document.addEventListener('click', function(event) {
    if (event.target && event.target.id === 'subscribeButton') {
        fbq('track', 'Subscribe');
    }
});



